
import { Input, InputProps, NumericTextBox, NumericTextBoxProps } from '@progress/kendo-react-inputs';
import { Label, Error } from "@progress/kendo-react-labels";
import { NumberFormatOptions } from '@progress/kendo-react-intl';
import React from 'react';

import styles from './_number-format-numeric-textbox.module.scss';

export interface NumberFormatNumericTextBoxProps extends NumericTextBoxProps {
  showSpinners?: boolean;
  error?: boolean;
  fullWidth?: boolean;
  helperText?: string;
  numberType?: 'decimal' | 'currency' | 'percent' | 'scientific' | 'accounting' | undefined | NumberFormatOptions;
}


export default function NumberFormatNumericTextBox (props:  NumberFormatNumericTextBoxProps) {
  const [focused, setFocused] = React.useState(false)  
  const format: string | NumberFormatOptions | undefined = props.numberType === 'decimal'
    ? {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}
    : props.numberType === 'currency'
      ? {style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2}
      : props.numberType === 'percent'
        ? {style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2}
        : props.format;

  return (
    <div className={styles.formattedInputContainer}>
      <NumericTextBox
        className={styles.inputContainer}
        {...props}
        label={undefined}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        inputStyle={{textAlign: 'right', width: props.fullWidth ? '100%' : undefined}}
        spinners={props.showSpinners ?? false}
        valid={!props.error}
        validationMessage={props.validationMessage}
        fillMode={'outline'}
        format={format}
      />
      {((props.label && props.value) || focused) && (
        <Label style={focused ? {color: "var(--kendo-color-primary)"} : undefined} className={styles.label} editorValid={!props.error}>{props.label}</Label>
      )}
      {props.label && !props.value && !focused && (
        <Label className={styles.labelNoValue} editorValid={!props.error}>{props.label}</Label>
      )}
      {props.error && props.validationMessage && <Error style={{marginLeft: 14}}>{props.validationMessage}</Error>}
    </div> 
  );
}
